import { Fragment, useCallback, useMemo } from 'react';
import type { SurveyQuestionType } from '@trinity/chat/enums';
import { useSurveyQuestionResponsesData } from '@/containers/SurveyResponses/hooks';
import { SurveyResponsesHeader } from '@/components/presentation/ProjectSurveyResponses';
// import { MatrixRangeChart } from './MatrixRange.Chart';
import { MatrixRangeData } from './MatrixRange.Data';
import { MatrixRangeChart } from './MatrixRange.Chart.Spectrum';
import styles from './style/Options.module.css';

export const MatrixRangeResponses = () => {

  const { question } = useSurveyQuestionResponsesData<SurveyQuestionType.MatrixRange>();

  return (
    <Fragment>
      <SurveyResponsesHeader
        question={question} />
      <MatrixRangeChart />
      <div className={styles.options}>
        <MatrixRangeData />
      </div>
    </Fragment>
  );
};

export default MatrixRangeResponses;